<template>
  <Dialog
    v-observe-keyboard.l2.enter="onConsentGiven"
    :heading="$t('recording_consent_modal.title')"
    :min-width="500"
    hide-actions
    :closeButton="false"
    data-cy="recording-consent-modal"
    scrimClickAction=""
    escapeKeyAction=""
    :class="{ branded: isBranded }"
  >
    <div slot="content" class="unselectable recording-consent-modal-content">
      <div class="recording-consent-modal-description-wrapper">
        <div class="recording-consent-modal-description">
          {{ $t('recording_consent_modal.description') }}
        </div>
        <div class="recording-consent-modal-more-details">
          {{ $t('recording_consent_modal.more_details') }}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.vonage.com/legal/privacy-policy"
            >{{ $t('recording_consent_modal.privacy_policy') }}</a
          >.
        </div>
      </div>
    </div>

    <div slot="footer-buttons" class="footer-buttons">
      <EndMeetingButton
        :shouldCloseWindow="shouldCloseWindow"
        data-cy="recording-consent-leave-meeting-btn"
        :label="leaveBtnText"
        :endForAll="isSessionOwner"
      />
      <vwc-button
        :label="agreeBtnText"
        layout="filled"
        data-cy="recording-consent-agree-btn"
        connotation="cta"
        appearance="outlined-light"
        @click="onConsentGiven"
      ></vwc-button>
    </div>
  </Dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import EndMeetingButton from '@/components/buttons/EndMeetingButton.vue';
import Dialog from '@/components/Dialog.vue';

export default {
  name: 'RecordingConsentModal',

  components: {
    Dialog,
    EndMeetingButton
  },

  props: {
    agreeBtnText: {
      type: String,
      required: true
    },
    leaveBtnText: {
      type: String,
      required: true
    },
    shouldCloseWindow: {
      type: Boolean,
      default: true
    },
    onConsentAction: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters(['isSessionOwner']),
    ...mapState(['isBranded']),
    ...mapGetters('recordings', ['isRecording'])
  },

  methods: {
    ...mapActions(['setIsRecordingConsentGiven', 'leaveSession']),

    onConsentGiven() {
      this.setIsRecordingConsentGiven(true);
      this.onConsentAction();
    }
  }
};
</script>
<style scoped>
.footer-buttons {
  display: flex;
  align-items: center;
  justify-content: end;
  padding-top: 12px;
  text-align: right;
  gap: 16px;
}

.recording-consent-modal-description-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 24px 0;
}

.recording-consent-modal-description-wrapper
  .recording-consent-modal-description,
.recording-consent-modal-description-wrapper
  .recording-consent-modal-more-details {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin: 0;
}

.recording-consent-modal-description-wrapper
  .recording-consent-modal-more-details
  a {
  text-decoration: underline;
  color: rgb(153, 64, 255);
  text-underline-color: rgb(153, 64, 255);
}

@media only screen and (max-width: 850px) {
  vwc-dialog {
    --mdc-dialog-min-width: 450px !important;
    --mdc-dialog-max-width: unset !important;
  }
}

@media only screen and (max-width: 600px) {
  vwc-dialog {
    --mdc-dialog-min-width: unset !important;
    --mdc-dialog-max-width: unset !important;
  }
}
</style>
